import { render, staticRenderFns } from "./classKcChoose.vue?vue&type=template&id=bd949414&scoped=true"
import script from "./classKcChoose.vue?vue&type=script&lang=js"
export * from "./classKcChoose.vue?vue&type=script&lang=js"
import style0 from "./classKcChoose.vue?vue&type=style&index=0&id=bd949414&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd949414",
  null
  
)

export default component.exports